import * as React from 'react';

import {useQuery, useApolloClient} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetDripSequence as GetDripSequenceQuery,
    GetDripSequenceVariables as GetDripSequenceQueryVariables,
    DripSequenceFragment as DripSequence,
    DripSequenceStubFragment as DripSequenceStub,
} from 'nutshell-graphql-types';

import NEWSLETTER_STUB_FRAGMENT from './graphql/fragments/drip-sequence-stub-fragment.graphql';
import GET_NEWSLETTER from './graphql/queries/get-drip-sequence.graphql';

type Props = {
    dripSequenceId: string;
    children: (arg1: {
        dripSequence: DripSequence | null | undefined;
        dripSequenceStub: DripSequenceStub | null | undefined;
        isLoading: boolean;
        error: string | null | undefined;
        refetch: () => Promise<any>;
    }) => React.ReactElement;
};

export function DripSequenceQuery(props: Props) {
    const client = useApolloClient();
    let dripSequenceStub: DripSequenceStub | null | undefined;

    try {
        dripSequenceStub = client.readFragment({
            id: props.dripSequenceId,
            fragmentName: 'DripSequenceStubFragment',
            fragment: NEWSLETTER_STUB_FRAGMENT,
        });
    } catch {
        // Empty
    }

    const {
        data,
        error,
        loading: isLoading,
        refetch,
    } = useQuery<GetDripSequenceQuery, GetDripSequenceQueryVariables>(GET_NEWSLETTER, {
        variables: {dripSequenceId: props.dripSequenceId},
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
    });

    // This could be used to fetch a broadcast or newsletter, which is why this
    // throws a flow error.
    const dripSequence = data ? data.campaign : null;

    return props.children({
        dripSequence,
        dripSequenceStub,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
        refetch,
    });
}
